export const EVENTS_OVERVIEW_LIMIT = 9;
